export const init = () => {
    if (document.querySelector('.b-model-box')){
        const favButtons = document.querySelectorAll('.b-model-box .favourites');
        favButtons.forEach((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                item.classList.toggle('active');
            });
        });
    }
}